import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { MbConstants } from 'src/app/mb/shared/mb-constants'
import { MbPaymentMode } from '../../../../models'

@Component({
  selector: 'mb-checkout-payment-invoice-partial',
  templateUrl: './mb-checkout-payment-invoice-partial.component.html',
})
export class MbCheckoutPaymentInvoicePartialComponent {

  constants = MbConstants
  poNo = ''
  @Input() paymentMode: MbPaymentMode | undefined

  @Input() set poNumber (poNumber: string) {
    this.poNo = poNumber
    this.formGroup?.patchValue({ poNumber: poNumber })
  }

  @Input() isSelectedPayment = false
  @Input() formGroup: UntypedFormGroup | undefined

  submitPoNumber (): void {
    this.poNo = this.formGroup?.get(this.constants.PO_NUMBER_CODE)?.value
    if (!this.formGroup?.valid) {
        this.formGroup?.markAllAsTouched()
    }
  }
}
